import req from '@sportninja/common/api/request'
import { useCallback, useState } from 'react'
import { RegistrationTypes } from '../types/Registration'

interface TypeObject {
  [key: string]: []
}

/**
 * 🔄 extractValues: Helper function to transform types API response
 * Extracts values from the types API response and creates a RegistrationTypes object
 */
function extractValues(data: TypeObject[]): RegistrationTypes {
  console.log('🔄 extractValues: Transforming types data', { data })
  const extracted: any = {}
  data.forEach((item) => {
    const key = Object.keys(item)[0]
    const mappedKey = key.replace('_type', '')
    extracted[mappedKey] = item[key]
  })
  return extracted as RegistrationTypes
}

/**
 * 🔄 useRegistrationTypes: Hook to fetch registration types from public API
 * Replaces the types fetching functionality from useRegistrationData
 */
export const useRegistrationTypes = () => {
  const [types, setTypes] = useState<RegistrationTypes | null>(null)

  const fetchTypes = useCallback(async () => {
    try {
      const raw = await req('/types/registration')
      const extractedTypes = extractValues(raw)
      console.log('🔄 fetchTypes: Successfully fetched types', {
        extractedTypes,
      })
      setTypes(extractedTypes)
    } catch (err) {
      console.error('❌ fetchTypes: Error fetching types', err)
      throw err instanceof Error
        ? err
        : new Error('An error occurred while fetching types')
    }
  }, [])

  return { types, fetchTypes }
}
